import { render, staticRenderFns } from "./PFSIModal.vue?vue&type=template&id=46771ff3&scoped=true"
import script from "./PFSIModal.vue?vue&type=script&lang=js"
export * from "./PFSIModal.vue?vue&type=script&lang=js"
import style0 from "./PFSIModal.vue?vue&type=style&index=0&id=46771ff3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46771ff3",
  null
  
)

export default component.exports